import {AutomationFilter} from "./automation-filter";

export class AutomationConfiguration {
  delay: number;
  min_time_interval: number;
  filters: AutomationFilter[];

  constructor(data: Partial<AutomationConfiguration> & {trigger?: {delay?: number}}) {
    this.delay = data.trigger?.delay;
    this.min_time_interval = data.min_time_interval;
    this.filters = data.filters.map(f => new AutomationFilter(f));
  }

  public valid(): boolean {
    if (!this.delay) {
      return false;
    }
    if (this.min_time_interval == null || this.min_time_interval < 0) {
      return false;
    }
    if (!this.filters || this.filters.length === 0) {
      return false;
    }
    return this.filters.every(f => f.valid());
  }

  public asRequest(): Partial<AutomationConfiguration> | any {
    return {
      trigger: {type: "transaction", delay: this.delay},
      min_time_interval: this.min_time_interval,
      filters: this.filters.map(f => f.asRequest())
    };
  }
}
